import * as collections from '@wix/auto_sdk_portfolio_collections';
import * as portfolioSettings from '@wix/auto_sdk_portfolio_portfolio-settings';
import * as projectItems from '@wix/auto_sdk_portfolio_project-items';
import * as projects from '@wix/auto_sdk_portfolio_projects';
import * as projectInCollections from '@wix/auto_sdk_portfolio_project-in-collections';
import * as syncedProject from '@wix/auto_sdk_portfolio_synced-project';

export {
  collections,
  portfolioSettings,
  projectItems,
  projects,
  projectInCollections,
  syncedProject,
};
